<template>
  <q-dialog
    v-model="shown"
    :persistent="loading"
  >
    <q-card style="min-width: 50%">
      <q-card-section>
        <div class="text-h5">
          Interac Refund
        </div>
      </q-card-section>

      <template v-if="$register">
        <q-card-section
          v-if="loading"
        >
          <div class="row justify-center items-center">
            <q-spinner
              color="primary"
              size="xl"
            />
          </div>
          <div class="text-h6 row justify-center items-center">
            <span v-if="!refundComplete">
              Insert/Swipe card on the reader...
            </span>
            <span v-else>
              Updating order details...
            </span>
          </div>
        </q-card-section>
        <q-card-section v-else>
          <div class="row text-h6">
            Refund requires the original payment card to be present.
          </div>

          <div class="row q-mt-lg text-caption">
            Ensure the customer has the card ready to swipe, then select the "Process" button.
          </div>
        </q-card-section>
      </template>

      <template v-else>
        <q-card-section>
          <div class="row text-h6">
            Refunds for interac payments are only available at the register.
          </div>

          <div class="row q-mt-lg text-caption">
            Interac refunds require the original payment card to be present.
          </div>
        </q-card-section>
      </template>

      <q-card-section class="row justify-end">
        <q-btn
          :disable="loading"
          class="q-mx-sm"
          :label="$register ? 'Cancel' : 'Close'"
          color="secondary"
          outline
          @click="shown = false"
        />
        <template v-if="$register">
          <q-btn
            v-if="$payments.status.connected"
            :disable="loading"
            :label="`Process ${$i18n.n(refundOption.amount, 'currency')} with reader`"
            color="primary"
            @click="process"
          />
          <q-btn
            v-else
            :disable="connectingToReader"
            color="primary"
            outline
            @click="connectToReader"
          >
            {{ $t('payment.actions.reconnectToChipReader') }}
          </q-btn>
        </template>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: 'InteracRefundDialog',
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  emits: ['refund-success'],
  data () {
    return {
      shown: false,
      originalPayment: null,
      loading: false,
      refundComplete: false,
      connectingToReader: false
    }
  },
  watch: {
    shown (val) {
      if (!val) {
        this.loading = false
        this.refundComplete = false
        this.originalPayment = null
      }
    }
  },
  methods: {
    show (refundOption) {
      this.refundOption = refundOption
      this.shown = true
    },
    async connectToReader () {
      try {
        this.connectingToReader = true
        await this.$payments.connectToReader()
      } catch (error) {
        this.$mh.showErrors(['Error connecting to reader', error.message])
      } finally {
        this.connectingToReader = false
      }
    },
    async process () {
      try {
        this.loading = true
        const { success, error, result } = await this.$payments.interacRefund(this.refundOption)

        if (success) {
          const results = await this.order.addInteracRefundToOrder(result.refund.id)

          if (results.data?.success) {
            await this.order.fetch(true)
            this.$emit('refund-success', this.refundOption)
          } else {
            this.$mh.showErrors([results.data?.error])
          }
        } else {
          this.$mh.showErrors([error])
        }
      } finally {
        this.loading = false
        this.shown = false
      }
    }
  }
}

</script>
